<template>
    <div
        class="bg-white/50 hover:bg-white/70 transition shadow-sm rounded-lg"
        :class="{ 'animate-category-blink': props.highlighted }"
    >
        <button
            type="button"
            class="flex w-full items-center gap-2 px-3 py-2.5 text-start bg-transparent border-0 cursor-pointer rounded-lg"
            @click="emit('toggle')"
        >
            <span
                class="inline-block size-3 rounded-[3px] shrink-0"
                :class="CATEGORY_COLORS[props.category.color].bg"
            ></span>
            <span class="flex-1 truncate text-sm text-slate-600">{{ props.category.displayName }}</span>
            <vx-badge color="primary" size="2xs">
                {{ props.threads.length }}
            </vx-badge>
            <font-awesome-icon
                widthAuto
                class="text-xs text-slate-400 transition-transform"
                :class="{ 'rotate-180': props.expanded }"
                :icon="faChevronDown"
            ></font-awesome-icon>
        </button>
        <div v-if="props.expanded" class="px-2 pb-2 flex flex-col gap-1.5">
            <message-hub-thread-sidebar-row
                v-for="thread in props.threads"
                :key="thread.contact_id"
                :thread="thread"
                :suggestedReply="thread.suggestedReply"
            ></message-hub-thread-sidebar-row>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxBadge } from '@voxie/frontend-components';
import MessageHubThreadSidebarRow from '~/components/message-hub/message-hub-threads/MessageHubThreadSidebarRow.vue';
import { CATEGORY_COLORS, type IntelligentCategory, type IntelligentThread } from './useIntelligentInbox';

const props = defineProps<{
    category: IntelligentCategory;
    threads: IntelligentThread[];
    expanded: boolean;
    highlighted: boolean;
}>();

const emit = defineEmits<{
    toggle: [];
}>();
</script>

<style scoped>
@keyframes category-blink {
    0%,
    100% {
        background-color: rgb(255 255 255 / 0.5);
    }
    50% {
        background-color: rgb(255 255 255 / 1);
    }
}
.animate-category-blink {
    animation: category-blink 0.6s ease-in-out 2;
}
</style>
